import React from "react";

import GenericPullConfigListing from "../GenericPullConfigListing";
import UpwindCredentialsForm from "./UpwindCredentialsForm";
import UpwindMappingForm from "./UpwindMappingForm";

const UpwindConfigListing = (props) => {
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={UpwindMappingForm}
      CredentialsForm={UpwindCredentialsForm}
    />
  );
};

export default UpwindConfigListing;